import React, { useState } from 'react';
import { Pencil, Trash2, UserCircle2, Plus, Save, XCircle, ArrowLeft } from 'lucide-react';
import { Card } from 'flowbite-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const AddUser = () => {
    const [team, setTeam] = useState([]);
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('viewer');
    const [isEditing, setIsEditing] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const navigate = useNavigate();

    const handleAddUser = () => {
        if (!email) {
            toast.error('Please enter an email address');
            return;
        }
        const newUser = {
            email,
            role,
            password: '123456789'
        };
        setTeam([...team, newUser]);
        setEmail('');
        setRole('viewer');
        toast.success('User added successfully!');
    };

    const handleEditUser = (index) => {
        const user = team[index];
        setEmail(user.email);
        setRole(user.role);
        setIsEditing(true);
        setEditIndex(index);
    };

    const handleSaveEdit = () => {
        if (!email) {
            toast.error('Please enter an email address');
            return;
        }
        const updatedTeam = team.map((user, index) => 
            index === editIndex ? { ...user, email, role } : user
        );
        setTeam(updatedTeam);
        setEmail('');
        setRole('viewer');
        setIsEditing(false);
        setEditIndex(null);
        toast.success('User updated successfully!');
    };

    const handleCancelEdit = () => {
        setEmail('');
        setRole('viewer');
        setIsEditing(false);
        setEditIndex(null);
    };

    const handleDeleteUser = (index) => {
        const updatedTeam = team.filter((_, i) => i !== index);
        setTeam(updatedTeam);
        toast.success('User deleted successfully!');
    };

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <div className="flex justify-center p-8">
            <Card className="w-full max-w-4xl">
                <div className="p-6">
                    <div className="flex justify-between items-center mb-6">
                        <button onClick={handleBack} className="flex items-center text-blue-500 hover:text-blue-700">
                            <ArrowLeft className="mr-2 h-5 w-5" /> Back
                        </button>
                        <h2 className="text-2xl font-bold">
                            {isEditing ? 'Edit Team Member' : 'Add Team Member'}
                        </h2>
                    </div>
                    
                    <div className="grid gap-6 md:grid-cols-2 mb-6">
                        <div>
                            <label className="block text-sm font-medium mb-2">Email Address</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter email address"
                                className="w-full px-4 py-2 border rounded-lg text-black focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-2">Role</label>
                            <select
                                value={role}
                                onChange={(e) => setRole(e.target.value)}
                                className="w-full px-4 py-2 border rounded-lg text-black focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="viewer">Viewer</option>
                                <option value="editor">Editor</option>
                                <option value="admin">Admin</option>
                            </select>
                        </div>
                    </div>

                    <div className="flex space-x-4">
                        <button
                            onClick={isEditing ? handleSaveEdit : handleAddUser}
                            className={`flex items-center justify-center px-4 py-2 rounded-lg text-white transition-colors
                                ${isEditing 
                                    ? 'bg-green-500 hover:bg-green-600' 
                                    : 'bg-blue-500 hover:bg-blue-600'
                                }`}
                        >
                            {isEditing ? (
                                <><Save className="mr-2 h-4 w-4" /> Save Changes</>
                            ) : (
                                <><Plus className="mr-2 h-4 w-4" /> Add User</>
                            )}
                        </button>
                        {isEditing && (
                            <button
                                onClick={handleCancelEdit}
                                className="flex items-center justify-center px-4 py-2 rounded-lg text-white bg-red-500 hover:bg-red-600 transition-colors"
                            >
                                <XCircle className="mr-2 h-4 w-4" /> Cancel
                            </button>
                        )}
                    </div>

                    <div className="mt-8 overflow-x-auto">
                        <table className="w-full border-collapse">
                            <thead>
                                <tr className="bg-gray-50">
                                    <th className="px-6 py-3 text-left text-xs font-bold text-gray-500  uppercase tracking-wider">User</th>
                                    <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Role</th>
                                    <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {team.map((user, index) => (
                                    <tr key={index} className="odd:bg-gray-100 even:bg-gray-200 hover:bg-gray-300">
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{user.email}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{user.role}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                            <button onClick={() => handleEditUser(index)} className="text-blue-600 hover:text-blue-900 mr-4">
                                                <Pencil className="h-5 w-5" />
                                            </button>
                                            <button onClick={() => handleDeleteUser(index)} className="text-red-600 hover:text-red-900">
                                                <Trash2 className="h-5 w-5" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default AddUser;